import { NavLink, Outlet } from "react-router-dom";

import { siteConfig } from "../config/site";

export function SiteLayout() {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <div className="mx-auto w-full max-w-4xl px-6">
        <header className="flex items-center justify-between py-8">
          <NavLink
            to="/"
            className="font-display text-xl tracking-tight hover:opacity-70"
            aria-label={siteConfig.name}
          >
            {siteConfig.name}
          </NavLink>
          <nav className="flex items-center gap-6 text-sm">
            <NavLink
              to="/download"
              className={({ isActive }) =>
                isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
              }
            >
              Download
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
              }
            >
              About
            </NavLink>
            <NavLink
              to="/keys"
              className={({ isActive }) =>
                isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
              }
            >
              Keys
            </NavLink>
            <a
              href={siteConfig.links.repo}
              target="_blank"
              rel="noreferrer"
              className="text-muted-foreground hover:text-foreground"
            >
              Source
            </a>
          </nav>
        </header>

        <div className="pb-8 pt-12">
          <Outlet />
        </div>

        <footer className="border-t border-border/60 py-12 text-sm">
          <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
            <div className="space-y-3">
              <p className="font-display text-base tracking-tight">{siteConfig.name}</p>
              <p className="max-w-xs text-muted-foreground">
                Free, open-source password manager designed for end-to-end encryption.
              </p>
            </div>

            <div className="flex flex-wrap gap-x-8 gap-y-4 text-muted-foreground sm:text-right">
              <div className="space-y-2">
                <NavLink className="block hover:text-foreground" to="/download">
                  Download
                </NavLink>
                <NavLink className="block hover:text-foreground" to="/about">
                  About
                </NavLink>
                <NavLink className="block hover:text-foreground" to="/keys">
                  Keys
                </NavLink>
              </div>
              <div className="space-y-2">
                <NavLink className="block hover:text-foreground" to="/privacy">
                  Privacy
                </NavLink>
                <NavLink className="block hover:text-foreground" to="/terms">
                  Terms
                </NavLink>
              </div>
              <div className="space-y-2">
                <a className="block hover:text-foreground" href={siteConfig.links.repo} target="_blank" rel="noreferrer">
                  Source
                </a>
                <a className="block hover:text-foreground" href={siteConfig.links.issues} target="_blank" rel="noreferrer">
                  Roadmap
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col gap-4 border-t border-border/60 pt-8 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
            <p>© {new Date().getFullYear()} {siteConfig.llcName}</p>
            <p className="font-mono">
              {siteConfig.privacyEmail} · {siteConfig.dmcaEmail}
            </p>
          </div>
        </footer>
      </div>
    </main>
  );
}
